<template>
  <div class="flex flex-col gap-1 p-2">
    <button
      v-for="variant in variants"
      :key="variant"
      type="button"
      :class="[
        'flex cursor-pointer items-center rounded-md px-2 py-1.5 text-left transition-colors hover:bg-surface-muted',
        value === variant ? 'bg-surface-muted' : '',
      ]"
      @click="select(variant)">
      <UiStatusChip
        :variant="variant"
        :label="label"
        :isSquared="true" />
    </button>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TStatusChipVariant } from '@team-milva/lab-components'
import { STATUS_CHIP_VARIANTS } from '@/globals/typescript/utils/statusChipVariants'

export default {
  name: 'StatusChipVariantPickerMenu',

  emits: ['close'],

  props: {
    value: {
      type: String as PropType<TStatusChipVariant>,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    onSelect: {
      type: Function as PropType<(variant: TStatusChipVariant) => void>,
      required: true,
    },
  },

  computed: {
    variants(): TStatusChipVariant[] {
      return STATUS_CHIP_VARIANTS
    },
  },

  methods: {
    select(variant: TStatusChipVariant): void {
      this.onSelect(variant)
      this.$emit('close')
    },
  },
}
</script>
